import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import Footer from './Footer';

const inputClass = "w-full border border-gray-300 p-3 rounded-lg bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-gray-900 focus:border-gray-900 transition-colors";

const Register = () => {
  const [fullName, setFullName] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [attendeeCount, setAttendeeCount] = useState(1);
  const [registered, setRegistered] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [progress, setProgress] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const autoCloseTimer = useRef(null);

  useEffect(() => () => clearTimeout(autoCloseTimer.current), []);

  const closeSuccess = () => {
    clearTimeout(autoCloseTimer.current);
    setRegistered(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMessage('');
    setSubmitting(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/api/registration/upload`, {
        fullName,
        phone,
        email,
        attendeeCount,
      });

      if (response.status === 200) {
        setRegistered(true);
        setFullName('');
        setPhone('');
        setEmail('');
        setAttendeeCount(1);
        autoCloseTimer.current = setTimeout(closeSuccess, 20000);
      }
    } catch (error) {
      setErrorMessage('Failed to submit. Please try again. / Ntibyakunze kohereza. Ongera ugerageze.');
      setProgress(100);
      setTimeout(() => {
        setProgress(0);
        setErrorMessage('');
      }, 5000);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div>
      <div className="flex items-center justify-center px-4 pt-[120px] pb-16 min-h-screen bg-white">
        <div className="bg-white border border-gray-200 text-gray-900 p-6 sm:p-8 rounded-xl max-w-md w-full">
          {registered ? (
            <div className="flex flex-col items-center text-center py-4">
              <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mb-5">
                <svg className="w-9 h-9 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                  <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                </svg>
              </div>
              <h2 className="text-2xl font-glsnecb tracking-wide uppercase mb-2">Registration Successful</h2>
              <p className="text-gray-500 text-sm mb-1">Wiyandikishije neza!</p>
              <p className="text-gray-600 text-sm leading-relaxed mb-6 max-w-xs">
                Thank you, your spot for None Urabikoze Concert has been saved. We look forward to seeing you there.
              </p>
              <div className="flex flex-col sm:flex-row gap-3 w-full">
                <a
                  href="/invite"
                  className="flex-1 text-center bg-gray-900 text-white text-sm font-medium py-2.5 px-6 rounded-lg hover:bg-black transition-colors"
                >
                  Invite a Friend
                </a>
                <button
                  onClick={closeSuccess}
                  className="flex-1 border border-gray-300 text-gray-700 text-sm font-medium py-2.5 px-6 rounded-lg hover:bg-gray-50 transition-colors"
                >
                  Close
                </button>
              </div>
            </div>
          ) : (
            <>
              <h2 className="text-2xl sm:text-3xl text-center mb-2 font-glsnecb tracking-wide uppercase">
                Register for None Urabikoze Concert
              </h2>
              <p className="text-center text-gray-500 text-sm leading-relaxed mb-6">
                Let us know you're coming so we can prepare well for everyone.
              </p>

              <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
                <div>
                  <input
                    type="text"
                    placeholder="Full Name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                    required
                    className={inputClass}
                  />
                  <span className="block text-gray-400 text-[11px] mt-1 ml-1">Amazina yanyu / Full Name</span>
                </div>

                <div>
                  <input
                    type="tel"
                    placeholder="Phone Number (optional)"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className={inputClass}
                  />
                  <span className="block text-gray-400 text-[11px] mt-1 ml-1">Numero ya telefoni (si itegeko)</span>
                </div>

                <div>
                  <input
                    type="email"
                    placeholder="Email Address (optional)"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className={inputClass}
                  />
                  <span className="block text-gray-400 text-[11px] mt-1 ml-1">Imeyili (si itegeko)</span>
                </div>

                <div>
                  <label className="block text-gray-700 text-sm font-medium mb-1">Number of attendees with you</label>
                  <span className="block text-gray-400 text-[11px] mb-2">Umubare w'abantu bazaza nawe</span>
                  <input
                    type="number"
                    min="1"
                    value={attendeeCount}
                    onChange={(e) => setAttendeeCount(e.target.value)}
                    required
                    className={inputClass}
                  />
                </div>

                <button
                  type="submit"
                  disabled={submitting}
                  className="w-full bg-gray-900 text-white text-sm font-medium py-3 px-4 rounded-lg hover:bg-black disabled:opacity-50 transition-colors"
                >
                  {submitting ? 'Submitting...' : 'Register / Iyandikishe'}
                </button>
              </form>
              <p className="text-center text-gray-400 text-xs mt-5">
                Already registered?{' '}
                <a href="/invite" className="text-gray-700 font-medium hover:underline">Invite a friend</a>
              </p>
            </>
          )}
        </div>
      </div>

      {errorMessage && (
        <div className="fixed top-6 left-4 right-4 sm:mx-auto sm:w-80 bg-red-100 text-red-900 border-red-500 pt-2 rounded-t-md shadow-md z-50">
          <div className="flex justify-center items-center">
            <span className="text-center p-1">{errorMessage}</span>
          </div>
          <div className="h-1 mt-1 bg-red-300">
            <div style={{ width: `${progress}%` }} className="h-full bg-red-700 transition-all duration-500" />
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default Register;
